import { AuthScreen } from '@/components/domain/auth/AuthScreen';
import { SignInForm } from '@/components/domain/auth/SignInForm';

export default function SignInScreen() {
  return (
    <AuthScreen title="Welcome back" subtitle="Pick up where you left off.">
      <SignInForm />
    </AuthScreen>
  );
}
